import React, { useCallback, useState } from "react";
import "./backup.css";
import { FileUpload } from "./fileUpload";

export interface BackupProps {
    collections: string[];
    onUpload?: () => void;
}

interface UploadResult {
    type: 'success' | 'error';
    message: string;
}

type FileMap = Record<string, File | undefined>;

export function Backup({ collections, onUpload }: BackupProps) {

    const [uploading, setUploading] = useState(false);
    const [files, setFiles] = useState<FileMap>({});
    const [uploadResult, setUploadResult] = useState<UploadResult>()

    const handleFileChange = useCallback((file, collection) => {
        setFiles((files) => ({ ...files, [collection]: file }));
    }, []);

    const upload = useCallback(async (files) => {
        setUploading(true);

        try {
            const formData = new FormData();
            for (const key in files) {
                formData.append(key, files[key], files[key].name);
            }
            const response = await fetch(`api/backup`, { // Your POST endpoint
                method: 'POST',
                body: formData
            });

            const responseJsonData = await response.json();

            if (response.status >= 200 && response.status < 300) {
                setFiles({});
                setUploadResult({ type: 'success', message: 'File uploaded' });
                onUpload?.();
            } else {
                setUploadResult({ type: 'error', message: responseJsonData.error })
            }
            setUploading(false);

        } catch (error) {
            setUploadResult({ type: 'error', message: error.message })
            setUploading(false);
        }
    }, [onUpload]);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        if (Object.keys(files).length > 0) {
            upload(files);
        } else {
            setUploadResult({ type: 'error', message: 'Please select a file' })
        }
        return false;

    }, [files, upload]);

    const onDismissAlert = useCallback(() => {
        setUploadResult(undefined);
    }, []);

    return (
        <div>
            <label>Download backup:</label>
            <p>
                <a href={`api/backup${collections.length === 1 ? `/${collections[0]}` : ''}`} className="btn btn-primary" target="_blank" rel="noreferrer">
                    <span className="glyphicon glyphicon-floppy-save" /> {collections.length > 1 ? 'collections.zip' : `${collections[0]}.json`}
                </a>
            </p>

            <hr />

            <label>Restore backup:</label>
            <form onSubmit={handleSubmit}>
                {collections.map(coll => (
                    <FileUpload key={coll} collection={coll} fileName={files[coll]?.name} fileChange={handleFileChange} />
                ))}
                <div className="form-group">
                    <button className={`btn btn-primary`} disabled={Object.keys(files).length === 0 || uploading} type="submit">
                        <span className="glyphicon glyphicon-arrow-up" /> Upload {uploading ? <span className="glyphicon glyphicon-refresh glyphicon-refresh-animate spin"></span> : ''}

                    </button>

                </div>
            </form>

            {uploadResult && (
                <div className={`alert alert-${uploadResult.type === 'success' ? 'success' : 'danger'} alert-dismissible`} role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={onDismissAlert}><span aria-hidden="true">&times;</span></button>
                    {uploadResult.message}
                </div>
            )}
        </div>
    );
}